import './style/TableBlock.css';
import { InlineMath } from 'react-katex';
import 'katex/dist/katex.min.css';

function TableBlock({ headers, rows }) {
  const renderCell = (cell) => {
    // If cell is a string, return it as-is
    if (typeof cell === 'string') {
      return cell;
    }
    
    // If cell is a single block object (not an array), handle it
    if (cell && typeof cell === 'object' && !Array.isArray(cell) && cell.type) {
      switch (cell.type) {
        case "text":
          return <span>{cell.content}</span>;
        case "inline_math":
          return <InlineMath math={cell.content} />;
        default:
          return null;
      }
    }
    
    // If cell is an array of blocks, render each block
    if (Array.isArray(cell)) {
      return cell.map((block, i) => {
        switch (block.type) {
          case "text":
            return <span key={i}>{block.content}</span>;
          case "inline_math":
            return <InlineMath key={i} math={block.content} />;
          default:
            return null;
        }
      });
    }
    
    return cell;
  };

  return (
    <figure className="table">
      <table>
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th key={i}>{renderCell(h)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>{renderCell(cell)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}

export default TableBlock;